import React from 'react';

export const PlusCircle = () => (
    <>
        <circle cx='12' cy='12' r='9' />
        <line x1='9' y1='12' x2='15' y2='12' />
        <line x1='12' y1='9' x2='12' y2='15' />
    </>
);